import cn from 'classnames'
import AlertTriangleIcon from 'ext-ui/svg/icon/AlertTriangleIcon'
import CheckmarkIcon from 'ext-ui/svg/icon/CheckmarkIcon'
import React, { ReactElement } from 'react'
import { useTranslate } from 'src/localization/Trns'

import style from './DowngradeCardCount.style'

interface DowngradeCardCountProps {
  usage: number
  overBy: number
  withinLimit: boolean
  billingCycleEndShort: string | null
}

export default function DowngradeCardCount(
  props: DowngradeCardCountProps,
): ReactElement {
  const { usage, overBy, withinLimit, billingCycleEndShort } = props
  const translate = useTranslate()

  const label = withinLimit
    ? translate('active virtual cards')
    : billingCycleEndShort
      ? translate('cards will be deactivated on ${billingCycleEndShort}', {
          billingCycleEndShort,
        })
      : translate('cards will be deactivated at the end of your billing cycle')

  return (
    <div
      className={cn('DowngradeCardCount', { 'over-limit': !withinLimit })}
      css={style}
      data-testid="downgrade-card-count"
    >
      {withinLimit ? (
        <span
          className="DowngradeCardCount-badge DowngradeCardCount-badge--ok"
          data-testid="downgrade-card-count-badge-within"
        >
          <CheckmarkIcon aria-hidden="true" />
          {translate('Within Starter limit')}
        </span>
      ) : (
        <span
          className="DowngradeCardCount-badge DowngradeCardCount-badge--over"
          data-testid="downgrade-card-count-badge-over"
        >
          <AlertTriangleIcon width={14} height={14} />
          {translate('${count} cards over limit', { count: String(overBy) })}
        </span>
      )}
      <div className="DowngradeCardCount-count-row">
        <span
          className="DowngradeCardCount-count"
          data-testid="downgrade-card-count-number"
        >
          {withinLimit ? usage : overBy}
        </span>
        <span className="DowngradeCardCount-label">{label}</span>
      </div>
    </div>
  )
}
